module.exports = __webpack_public_path__ + "img/KMS-M-16.2c333627.svg";